const addMonths = (date, months) => {
    const month = date.getMonth() + months;

    return new Date(date.getFullYear() + Math.trunc(month / 12), month % 12, 1);
};

export default addMonths;
